import React, { memo, useState } from 'react';
import MyProfile from './MyProfile';
import { Modal } from 'antd';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { AppstoreOutlined, UserOutlined,SettingOutlined} from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import DF from 'DisplayFramework';
import MyTasks from './MyTasks';
import LandingPageConfig from './configLandingPage';

export type MyProfileModalProps = {
  visible: boolean;
  onCancel: () => void;
};
const { Sider, Content } = Layout;

const MyProfileModal = (props: MyProfileModalProps) => {
  const { visible, onCancel } = props;
  const [collapsed, setCollapsed] = useState(false);

  const LendingLogo = (
    <div style={{ marginTop: '20px' }}>
      <Link to="/" style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src="data:image/png;base64,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"
          alt="logo"
          style={{ width: '90px', height: '35px', marginBottom: '20px' }}
        />
      </Link>
    </div>
  );
  

  const [currentItem, setCurrentItem] = useState('1');

  return (
    <DF.Provider pagcode="myprofile">
      <Modal
        bodyStyle={{ padding: 1 }}
        visible={visible}
        footer={null}
        onCancel={onCancel}
        width={1300}
      >
        <Layout style={{ padding: 0 }}>
          <Sider
            // collapsible
            // collapsed={collapsed}
            // onCollapse={(value) => setCollapsed(value)}
            width={250}
          >
            <Menu
              className="menu-style"
              selectedKeys={[currentItem]}
              onClick={({ key }) => {
                setCurrentItem(key);
              }}
              style={{marginTop: '100px'}}
            >
             
              <Menu.Item
                className="ant-menu-item-myProfile"
                key="1"
                icon={<UserOutlined style={{color:'#000000'}}/>}
              >
                <GetLabel label="account" />{' '}
              </Menu.Item>
              <Menu.Item
                className="ant-menu-item-myProfile"
                key="2"
                icon={<AppstoreOutlined style={{color:'#000000'}}/>}
                
              >
                <GetLabel label="quickActions" />{' '}
              </Menu.Item>
              <Menu.Item className="ant-menu-item-myProfile" key="3" icon={<SettingOutlined style={{color:'#000000'}}/>}>
                <GetLabel label="landingPageConfig" />{' '}
              </Menu.Item>
              {/* <Menu.Item key="3" icon={<SettingOutlined />}>
                <GetLabel label="landingpageConfig" />{' '}
              </Menu.Item> */}
            </Menu>
          </Sider>
          <Layout>
            <Content style={{ paddingLeft: 30, paddingRight: 30 }}>
              {currentItem === '1' ? (
                <MyProfile onCancel={onCancel} />
              ) : currentItem === '2' ? (
                <MyTasks onCancel={onCancel} />
              ) : (
                <LandingPageConfig />
              )}
            </Content>
          </Layout>
        </Layout>
      </Modal>
    </DF.Provider>
  );
};

export default memo(MyProfileModal);
